export default __webpack_public_path__ + "static/media/test-bg.89088ca1.webp";